// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-move-quiz-js": () => import("./../../src/pages/move-quiz.js" /* webpackChunkName: "component---src-pages-move-quiz-js" */),
  "component---src-pages-select-team-js": () => import("./../../src/pages/select-team.js" /* webpackChunkName: "component---src-pages-select-team-js" */)
}

